import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
interface MarketingPopupCloseProps {
  className?: string;
  onClick?: () => void;
}
export function MarketingPopupClose(t0) {
  const $ = _c(6);
  const {
    className,
    onClick
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("absolute right-4 top-4 z-10 grid h-8 w-8 cursor-pointer place-items-center rounded-full bg-surface-base-secondary text-text-primary transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L11 11M11 1L1 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClick || $[4] !== t1) {
    t3 = <button type="button" onClick={onClick} aria-label="Close pop-up" className={t1}>{t2}</button>;
    $[3] = onClick;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}